import { ANALYTICS_EVENTS, trackEvent } from 'libs/analytics';

type TPaymentType = 'credit_card' | 'debit_card';

const trackAddPaymentInfo = (paymentType: TPaymentType, outcome: 'success' | 'error'): void =>
  trackEvent(ANALYTICS_EVENTS.ADD_PAYMENT_INFO, { payment_type: paymentType, outcome });

export default trackAddPaymentInfo;
